export const convertToKebabCase = (sectionName: string): string => {
  if (!sectionName) {
    return '';
  }

  return sectionName
    .replace(/\s*-\s*/g, '-')
    .replace(/["']/g, '')
    .replace(/(\d+)\s+(\d+\/\d+)/g, '$1-$2')
    .replace(/\s+/g, '-')
    .toLowerCase();
};

export const splitCamelCase = (str: string) => {
  return str.replace(/([a-z])([A-Z])/g, '$1 $2');
};
